import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { roleHome } from "@/lib/api";

function DeniedRedirect({ message, from }) {
    useEffect(() => {
        toast.error(message);
    }, [message]);
    return <Navigate to="/login" state={{ from }} replace />;
}

export default function ProtectedRoute({ children, role, adminOnly }) {
    const { user, ready } = useAuth();
    const location = useLocation();

    if (!ready || user === undefined) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="mono-label">Loading…</div>
            </div>
        );
    }
    if (!user) {
        return <DeniedRedirect message="Permission denied — please sign in to continue." from={location} />;
    }
    if (adminOnly && !user.is_admin && !user.is_admin_viewer) {
        toast.error("Permission denied — admin access only.");
        return <Navigate to={roleHome(user.role)} replace />;
    }
    if (role && user.role !== role) {
        // Bounce each role to its correct home.
        return <Navigate to={roleHome(user.role)} replace />;
    }
    // MFA gate: consultants who must enrol now (new signup OR grace expired) are
    // redirected to /mfa-setup. The setup route itself opts out of this check
    // via a wrapper that renders without ProtectedRoute.
    if (user.mfa_must_enroll_now && location.pathname !== "/mfa-setup") {
        return <Navigate to="/mfa-setup" replace />;
    }
    return children;
}
